module.exports = "/_next/static/images/15e83490ab0c9147fd583d443c9c0109-app-screenshots-lg@3x.jpg";